import { render } from "./CardReply.vue?vue&type=template&id=b3a8d872&scoped=true"
import script from "./CardReply.vue?vue&type=script&lang=js"
export * from "./CardReply.vue?vue&type=script&lang=js"

import "./CardReply.vue?vue&type=style&index=0&id=b3a8d872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a8d872"]])

export default __exports__